import { Box } from "@mui/material";
import { Code } from "~/components/code";

interface Props {
  mql: string | null | undefined;
}

export function CheckQueriesMql({ mql }: Props) {
  return (
    <Box>
      <Code copyButton className="coffeescript">
        {mql}
      </Code>
    </Box>
  );
}
